import React from 'react'
import skillsData from '../../assets/skillsdata.json'

const levelMap = {
    beginner: 1,
    learning: 2,
    intermediate: 3,
    advanced: 4
}

const Skillscard = ({ category }) => {
    const categoryData = skillsData.find(item => item.category === category)
    if (!categoryData) return null

    const { skills } = categoryData
    const mid = Math.ceil(skills.length / 2)
    const groups = [skills.slice(0, mid), skills.slice(mid)]

    return (
        <div className="skills__content">
            <h3 className="skills__title">{category.charAt(0).toUpperCase() + category.slice(1)} </h3>
            <div className="skills__box">
                {groups.map((group, idx) => (
                    <div className="skills__group" key={idx}>
                        {group.map((skill, i) => {
                            const levelCount = levelMap[skill.level.toLowerCase()] || 0
                            return (
                                <div className="skills__data" key={i}>
                                    <i className='bx bx-badge-check'></i>
                                    <div>
                                        <h3 className="skills__name">{skill.name}</h3>
                                        <div className="skills__squares">
                                            {[1, 2, 3, 4].map(n => (
                                                <span
                                                    key={n}
                                                    className={`square ${n <= levelCount ? 'filled' : ''}`}
                                                />
                                            ))}
                                        </div>
                                        {/*<span className="skills__level">{skill.level}</span>*/}
                                    </div>
                                </div>
                            )
                        })}
                    </div>
                ))}
            </div>
        </div>
    )
}

export default Skillscard
